import React, { useState, useEffect } from "react";

import i18n from "../i18n.js";
import { Link, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";

const FromWdsf = props => {
    // eslint-disable-next-line react/prop-types
    const { itemOptions } = props;
    const { t } = i18n;
    const comp = itemOptions.comp;

    const [code, setCode] = useState("");
    let { state } = useLocation();
    useEffect(() => {
        setCode(state?.code);
    }, []);
    let soloEnabled = false;
    let couplesEnabled = false;
    let teamsEnabled = false;
    comp?.categories.forEach(cat => {
        if (cat.subtype.solo) {
            soloEnabled = true;
        }
        if (cat.subtype.couple) {
            couplesEnabled = true;
        }
        if (cat.subtype.team) {
            teamsEnabled = true;
        }
    });
    return (
        <React.Fragment>
        <hr />
        <h2 className="display-6 mt-2">{t("reg.from_wdsf")}</h2>
        <p>{t("reg.wdsf.choose_type")}</p>
        <Container maxWidth="md" className="mb-2" sx={{ display: "flex", justifyContent: "center" }}>
            <Box>
                <Stack spacing={2} direction={{ xs: "column", sm: "row" }}>
                    {soloEnabled && (
                        <Link to="/wdsfSolo" state={{ code: code }}>
                            <Button variant="contained" size="large">
                                {t("reg.wdsf.solo")}
                            </Button>
                        </Link>
                    )}
                    {!soloEnabled && (
                        <Button variant="contained" size="large" disabled>
                            {t("reg.wdsf.solo")}
                        </Button>
                    )}
                    {couplesEnabled && (
                        <Link to="/wdsfCouple" state={{ code: code }}>
                            <Button variant="contained" size="large">
                                {t("reg.wdsf.couple")}
                            </Button>
                        </Link>
                    )}
                    {!couplesEnabled && (
                        <Button variant="contained" size="large" disabled>
                            {t("reg.wdsf.couple")}
                        </Button>
                    )}
                    {teamsEnabled && (
                        <Link to="/wdsfTeam" state={{ code: code }}>
                            <Button variant="contained" size="large">
                                {t("reg.wdsf.team")}
                            </Button>
                        </Link>
                    )}
                    {!teamsEnabled && (
                        <Button variant="contained" size="large" disabled>
                            {t("reg.wdsf.team")}
                        </Button>
                    )}
                </Stack>
            </Box>
        </Container>
        {/* </div>
        </div> */}
    </React.Fragment>
    );
};

export default FromWdsf;
